import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, getPDropdownData, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, onActionSubmittedUtil, prepareGetRequestHttpParams, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, setRequiredValidator, SnackbarService } from '@app/shared';
import { BadDebtSuspensionModel, CollectionModuleApiSuffixModels } from '@modules/collection';
import { loggedInUserData } from '@modules/others/auth.selectors';
import { UserModuleApiSuffixModels } from '@modules/user';
import { MomentService } from '@app/shared/services/moment.service';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-bad-debt-suspension-add-edit',
  templateUrl: './bad-debt-suspension-add-edit.component.html'
})
export class BadDebtSuspensionAddEditComponent extends PrimeNgTableVariablesModel implements OnInit {

  badDebtSuspensionAddEditForm: FormGroup;
  listSubscribtion: any;
  showGenerateFinalDemandList: boolean;
  divisionList: any = [];
  branchList = [];
  badDebitSuspensionId: any;
  isReasontDialogOpen: boolean = false;
  reasonForm: FormGroup;
  reasonList: any = [];
  issueForm: FormGroup;
  tab: Number = 0;
  finalDemandIssued: boolean = false;
  isFirstTime: boolean = true;

  constructor(
    private crudService: CrudService,
    private activatedRoute: ActivatedRoute,
    private rxjsService: RxjsService,
    private snackBarService: SnackbarService,
    private formBuilder: FormBuilder,
    private router: Router,
    private store: Store<AppState>, private momentService: MomentService) {
    super()
    this.rxjsService.setGlobalLoaderProperty(true);
    this.selectedTabIndex = 0
    this.tab = this.activatedRoute.snapshot.queryParams?.tab ? Number(this.activatedRoute.snapshot.queryParams?.tab) : 0;
    this.primengTableConfigProperties = {
      tableCaption: "Bad Debt Suspension",
      breadCrumbItems: [{ displayName: 'Credit Control', relativeRouterUrl: '' }, { displayName: 'Bad Debt Suspension', relativeRouterUrl: '/collection/bad-debt-suspension', queryParams: { tab: this.tab } }, { displayName: 'Bad Debt Suspension - Final Demand' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Final Demand',
            dataKey: 'bdiNumber',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: false,
            cursorLinkIndex: 0,
            columns: [
              { field: 'bdiNumber', header: 'BDI Number', width: '140px' },
              { field: 'customerName', header: 'Customer Name', width: '150px' },
              { field: 'customerId', header: 'Customer ID', width: '140px' },
              { field: 'debtorCode', header: 'Debtor Code', width: '140px' },
              { field: 'debtorName', header: 'Debtor Name', width: '150px' },
              { field: 'debtorContact1', header: 'Debtor Contact No. 1', width: '175px' },
              { field: 'debtorContact2', header: 'Debtor Contact No. 2', width: '175px' },
              { field: 'classification', header: 'Classification', width: '130px' },
              { field: 'address', header: 'Address', width: '150px' },
              { field: 'region', header: 'Region', width: '90px' },
              { field: 'division', header: 'Division', width: '100px' },
              { field: 'district', header: 'District', width: '120px' },
              { field: 'branch', header: 'Branch', width: '120px' },
              { field: 'outstandingBalance', header: 'Outstanding Balance', width: '170px' },
              { field: 'aging', header: 'Aging', width: '80px' },
              { field: 'noOfBucketsOutstanding', header: 'No Of Buckets Outstanding', width: '230px' },
              { field: 'status', header: 'Status', width: '120px' },
              { field: 'paymentMethod', header: 'Payment Method', width: '150px' },
              { field: 'paymentFrequency', header: 'Payment Frequency', width: '165px' },
              { field: 'debitDate', header: 'Debit Date', width: '120px', isDate: true },
              { field: 'lastPaymentDate', header: 'Last Payment Date', isDate: true, width: '165px' },
              { field: 'latestUnPaidDate', header: 'Latest Unpaid Date', isDate: true, width: '165px' },
              { field: 'latestUnPaidReason', header: 'Latest Unpaid Reason', width: '180px' },
              { field: 'lastWrapUpCode', header: 'Last Wrap Up Code', width: '165px' },
              { field: 'controller', header: 'Credit Controller Name', width: '185px' },
              { field: 'reason', header: 'Reason', width: '150px' },
              { field: 'notes', header: 'Notes', width: '150px' },
            ],
            isDateWithTimeRequired: true,
            apiSuffixModel: CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_FINAL_DEMAND,
            moduleName: ModulesBasedApiSuffix.COLLECTIONS,
            radioBtn: true
          },
        ]
      }
    }
    this.primengTableConfigProperties.caption = (this.tab == 0) ? 'Final Demand' : 'Potential Suspension';
    this.primengTableConfigProperties.breadCrumbItems[2].displayName = (this.tab == 0) ? 'Bad Debt Suspension - Final Demand' : 'Bad Debt Suspension - Potential Suspension'
    this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].dataKey = (this.tab == 0) ? 'badDebitSuspensionFinalDemandDebtorId' : 'badDebitSuspensionPotentialDebtorId';
    this.status = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false },
    ]
    this.badDebitSuspensionId = this.activatedRoute?.snapshot?.queryParams?.id;

  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.initForm();
    this.getDivisionDropdown()
    this.getReasonDropdown()
    if (this.badDebitSuspensionId) {
      this.getDetailsById()
    }
    this.reasonForm = this.formBuilder.group({
      badDebitSuspensionFinalDemandDebtorId: [''],
      badDebitSuspensionPotentialDebtorId: [''],
      isExcluded: [false],
      finalDemandRejectionReasonId: ["", Validators.required],
      notes: ['', Validators.required],
      modifiedUserId: [this.loggedInUserData.userId],
    })
    this.issueForm = this.formBuilder.group({
      referenceId: [this.badDebitSuspensionId],
      createdUserId: [this.loggedInUserData.userId],
      requestType: [this.tab == 0 ? 'BadDebtFinalDemand' : 'BadDebtPotentialSuspension']
    })
  }

  initForm(badDebtSuspensionModel?: BadDebtSuspensionModel) {
    let badDebtSuspensionDetailModel = new BadDebtSuspensionModel(badDebtSuspensionModel);
    this.badDebtSuspensionAddEditForm = this.formBuilder.group({});
    Object.keys(badDebtSuspensionDetailModel).forEach((key) => {
      if (typeof badDebtSuspensionDetailModel[key] === 'object') {
        this.badDebtSuspensionAddEditForm.addControl(key, new FormArray(badDebtSuspensionDetailModel[key]));
      } else {
        this.badDebtSuspensionAddEditForm.addControl(key, new FormControl(badDebtSuspensionDetailModel[key]));
      }
    });
    this.badDebtSuspensionAddEditForm = setRequiredValidator(this.badDebtSuspensionAddEditForm, ["divisionId", "branchId"]);
    this.badDebtSuspensionAddEditForm.get('createdUserId').setValue(this.loggedInUserData?.userId)
    this.badDebtSuspensionAddEditForm.get('divisionId').valueChanges.pipe(distinctUntilChanged(), debounceTime(500))
      .subscribe((res: any) => {
        if (res) {
          this.badDebtSuspensionAddEditForm.get("branchId").setValue(null, { emitEvent: false });
          this.getBranchByDivisionId();
        }
      })
  }
  getBranchByDivisionId(): void {
    if (this.badDebtSuspensionAddEditForm.get("divisionId").value) {
      this.crudService.dropdown(ModulesBasedApiSuffix.TECHNICIAN, UserModuleApiSuffixModels.UX_BRANCHES, prepareRequiredHttpParams({
        divisionId: this.badDebtSuspensionAddEditForm.get("divisionId").value
      }))
        .subscribe((response: IApplicationResponse) => {
          if (response.isSuccess && response.statusCode == 200) {
            if (this.badDebitSuspensionId) {
              this.branchList = getPDropdownData(response.resources, 'branchName', 'branchId', true);
            } else {
              this.branchList = getPDropdownData(response.resources, 'branchName', 'branchId');
            }
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        })
    };
  }
  // onSelctDate(e) {
  //   if (this.badDebtSuspensionAddEditForm.get('endDate').value && e > this.badDebtSuspensionAddEditForm.get('endDate').value) {
  //     this.badDebtSuspensionAddEditForm.get('endDate').setValue(null)
  //   }
  // }
  combineLatestNgrxStoreData() {
    combineLatest(
      [this.store.select(loggedInUserData)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
    });
  }

  onActionSubmited(e: any) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  getDivisionDropdown() {
    this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_DIVISIONS,
    ).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.divisionList = data.resources;
      }
    })
  }

  getReasonDropdown() {
    this.crudService.get(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.UX_FINAL_DEMAND_REJECTECTION_REASON,
    ).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.reasonList = data.resources;
      }
    })
  }

  getHeaderDetails() {
    let otherParams: any = { BadDebitSuspensionFinalDemandId: this.badDebitSuspensionId }
    this.crudService.get(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_FINAL_DEMAND_HEADER, undefined,
      false, prepareRequiredHttpParams(otherParams)
    ).subscribe(data => {
      let datas = {
        divisionId: data?.resources?.divisionId,
        branchId: data?.resources?.branchId ? data?.resources?.branchId.split(',') : null,
        isCurrent: data?.resources?.isCurrent,
        is30Days: data?.resources?.is30Days,
        is60Days: data?.resources?.is60Days,
        is90Days: data?.resources?.is90Days,
        is120Days: data?.resources?.is120Days,
        is150Days: data?.resources?.is150Days,
        is180Days: data?.resources?.is180Days,
        // endDate: data?.resources?.endDate ? new Date(data?.resources?.endDate) : null,
        // startDate: data?.resources?.startDate ? new Date(data?.resources?.startDate) : null,
      }
      this.badDebtSuspensionAddEditForm.patchValue(datas, { emitEvent: false });
      this.badDebtSuspensionAddEditForm.disable({ emitEvent: false });
      this.badDebtSuspensionAddEditForm.get('branchId').enable({ emitEvent: false });
      if (this.isFirstTime && this.badDebtSuspensionAddEditForm.get('branchId').value) {
        this.getBranchByDivisionId();
        this.isFirstTime = false;
      }
      this.finalDemandIssued = data?.resources?.finalDemandIssueed ? true : false;

      if (this.finalDemandIssued) {
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].radioBtn = false;
      }
    })

  }

  getDetailsById(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.rxjsService.setGlobalLoaderProperty(true);
    if (!otherParams) {
      otherParams = {}
    }
    if (this.tab == 0) {
      this.getHeaderDetails();
      otherParams['BadDebitSuspensionFinalDemandId'] = this.badDebitSuspensionId
    } else {
      otherParams['BadDebitSuspensionPotentialId'] = this.badDebitSuspensionId
    }
    let crudService = (this.tab == 0) ?
      this.crudService.get(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_FINAL_DEMAND_LIST, undefined,
        false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
      ) :
      this.crudService.get(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION_DOA, undefined,
        false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
      )
    crudService.subscribe((data: any) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        if (this.tab == 0) {
          this.dataList = data?.resources;
          this.totalRecords = data.totalCount
        } else {
          this.totalRecords = data.totalCount;
          let datas = {
            divisionId: data?.resources?.potentailSuspensionDetail?.divisionId,
            branchId: data?.resources?.potentailSuspensionDetail?.branchId ? data?.resources?.potentailSuspensionDetail?.branchId.split(',') : null,
            isCurrent: data?.resources?.potentailSuspensionDetail?.isCurrent,
            is30Days: data?.resources?.potentailSuspensionDetail?.is30Days,
            is60Days: data?.resources?.potentailSuspensionDetail?.is60Days,
            is90Days: data?.resources?.potentailSuspensionDetail?.is90Days,
            is120Days: data?.resources?.potentailSuspensionDetail?.is120Days,
            is150Days: data?.resources?.potentailSuspensionDetail?.is150Days,
            is180Days: data?.resources?.potentailSuspensionDetail?.is180Days,
            // endDate: data?.resources?.potentailSuspensionDetail?.endDate ? new Date(data?.resources?.potentailSuspensionDetail?.endDate) : null,
            // startDate: data?.resources?.potentailSuspensionDetail?.startDate ? new Date(data?.resources?.potentailSuspensionDetail?.startDate) : null,
          }
          this.finalDemandIssued = data?.resources?.potentailSuspensionDetail?.finalDemandIssueed ? true : false;
          if (this.finalDemandIssued) {
            this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].radioBtn = false;
          }
          this.badDebtSuspensionAddEditForm.patchValue(datas, { emitEvent: false });
          this.badDebtSuspensionAddEditForm.disable({ emitEvent: false });
          this.badDebtSuspensionAddEditForm.get('branchId').enable({ emitEvent: false });
          if (this.isFirstTime && this.badDebtSuspensionAddEditForm.get('branchId').value) {
            this.getBranchByDivisionId();
            this.isFirstTime = false;
          }
          this.dataList = data?.resources?.potentailSuspensionList;
        }
        this.showGenerateFinalDemandList = true;
      }
    })
  }


  getTableListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    if (otherParams) {
      if (this.tab == 0) {
        otherParams['BadDebitSuspensionFinalDemandId'] = this.badDebitSuspensionId
      } else {
        otherParams['BadDebitPotentialSuspensionId'] = this.badDebitSuspensionId
      }
    } else {
      otherParams = {}
      if (this.tab == 0) {
        otherParams['BadDebitSuspensionFinalDemandId'] = this.badDebitSuspensionId
      } else {
        otherParams['BadDebitPotentialSuspensionId'] = this.badDebitSuspensionId
      }
    }
    if (this.listSubscribtion && !this.listSubscribtion.closed) {
      this.listSubscribtion.unsubscribe();
    }
    this.rxjsService.setGlobalLoaderProperty(false);
    this.listSubscribtion = this.crudService.get(
      this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
      (this.tab == 0) ? CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_FINAL_DEMAND_DETAIL : CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION_LIST,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        if (this.tab == 0) {
          this.dataList = data.resources?.finalDemandList;
          this.totalRecords = data.totalCount;
        } else {
          this.dataList = data.resources;
          this.totalRecords = data.totalCount;
        }
      } else {
        this.dataList = null;
        this.totalRecords = 0;
      }
      this.reset = false;
    })
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any): void {
    switch (type) {
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        this.getDetailsById(row["pageIndex"], row["pageSize"], unknownVar)
        break;
      default:
    }
  }


  generateFinalDemandList() {
    if (this.badDebtSuspensionAddEditForm.invalid) {
      return
    }
    let formValue = this.badDebtSuspensionAddEditForm.getRawValue()
    formValue.branchId = formValue.branchId ? formValue.branchId?.toString() : null;
    // formValue.startDate = this.momentService.toFormateType(formValue.startDate, 'YYYY-MM-DD')
    if (this.tab == 0) {
      let crudService = !this.badDebitSuspensionId ? this.crudService.create(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.FIANL_DEMAND_LIST, formValue) :
        this.crudService.update(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.FIANL_DEMAND_LIST, formValue)
      crudService.subscribe((data: IApplicationResponse) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (data.isSuccess) {
          this.showGenerateFinalDemandList = true;
          this.badDebitSuspensionId = data.resources
          this.issueForm.get('referenceId').setValue(data.resources)
          this.getDetailsById()
        }
      })
    } else {
      let crudService = !this.badDebitSuspensionId ? this.crudService.create(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.POTENTIAL_SUSPENSION_LIST, formValue) :
        this.crudService.update(ModulesBasedApiSuffix.COLLECTIONS, CollectionModuleApiSuffixModels.POTENTIAL_SUSPENSION_LIST, formValue)
      crudService.subscribe((data: IApplicationResponse) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (data.isSuccess) {
          this.showGenerateFinalDemandList = true;
          this.badDebitSuspensionId = data.resources
          this.issueForm.get('referenceId').setValue(data.resources)
          this.getDetailsById()
        }
      })
    }
  }

  onCancelClick() {
    this.router.navigate(['/collection/bad-debt-suspension'], { queryParams: { tab: this.tab } });
  }

  onChangeSelecedRows(e) {
    if (!e) {
      return
    }

    if (this.finalDemandIssued) {
      this.snackBarService.openSnackbar('Final Demand cannot be edited.', ResponseMessageTypes.WARNING);
      return;
    }
    this.reasonForm.reset()
    this.selectedRows = e;
    this.isReasontDialogOpen = true
    this.reasonForm.get('badDebitSuspensionFinalDemandDebtorId').setValue(e?.badDebitSuspensionFinalDemandDebtorId)
    this.reasonForm.get('badDebitSuspensionPotentialDebtorId').setValue(e?.badDebitSuspensionPotentialDebtorId)
    this.reasonForm.get('isExcluded').setValue(e?.isExcluded)
    this.reasonForm.get('modifiedUserId').setValue(this.loggedInUserData.userId)
  }

  onResonSubmit() {
    if (this.reasonForm.invalid) {
      this.reasonForm.markAllAsTouched();
      return;
    }
    let formValue = this.reasonForm.getRawValue();
    if (this.tab == 0) {
      delete formValue.badDebitSuspensionPotentialDebtorId
    } else {
      delete formValue.badDebitSuspensionFinalDemandDebtorId
    }
    let crudService = (this.tab == 0) ? this.crudService.update(
      ModulesBasedApiSuffix.COLLECTIONS,
      CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_FINAL_DEMAND,
      formValue
    ) : this.crudService.update(
      ModulesBasedApiSuffix.COLLECTIONS,
      CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION,
      formValue
    )
    crudService.subscribe((response: IApplicationResponse) => {
      this.rxjsService.setGlobalLoaderProperty(false);
      this.isReasontDialogOpen = false
      if (response.isSuccess == true && response.statusCode == 200) {
        this.getDetailsById()
      }
    });
  }

  onClickIssue() {

    if (this.issueForm.invalid) {
      this.issueForm.markAllAsTouched();
      return;
    }
    let formValue = this.issueForm.value;
    formValue.supportingDocumentsUploadInsertDTOs = []  // mounicha said to pass as empty
    const formData = new FormData();
    formData.append("json", JSON.stringify(formValue));
    let crudService = (this.tab == 0) ? this.crudService.create(
      ModulesBasedApiSuffix.COLLECTIONS,
      CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_DOA,
      formData
    ) : this.crudService.create(
      ModulesBasedApiSuffix.COLLECTIONS,
      CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_DOA,
      formData
    )
    crudService.subscribe((response: IApplicationResponse) => {
      this.rxjsService.setGlobalLoaderProperty(false);
      this.isReasontDialogOpen = false
      if (response.isSuccess == true && response.statusCode == 200) {
        this.onCancelClick()
      }
    });
  }
}
